import type { FaireProductEntity } from "../../entity_types/product";

export const p_9dnr6aptff: FaireProductEntity = {
  token: "p_9dnr6aptff",
  type: "product",
  name: "Casper Boo Tea Towel",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl:
    "https://cdn.faire.com/fastly/15c37a7ddfd66864353060fd1be6044a0a39fa6b59596fe2536efc171cbb94c0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fc7d821e9a7d54ad09fe0da704d0f9116e26623203ee6616e30170727ce82764.jpeg",
  ],
  priceDollars: 9,
  description:
    'Kitchen Tea Towel\n\nThrow in the (ordinary) towel. \n\nMeet the product that started it all. The Geometry House Tea Towel is a cult favorite for a reason. Created from a tightly-woven Geoweave™ fabric that is ultra-absorbent, quick-drying and never wrinkles, this towel is built to work – while looking like a dream.\n\n\n...\n\n * ♺ Made from post-consumer recycled materials \n * 18" x 30" \n * Single-sided print \n...\n\n\nChore responsibly. \n\nFrom drying dishes to wiping up spills to accenting your kitchen with the season’s most enchanting prints, this Tea Towel does it all – without a negative impact on the environment. Our towels are created from post-consumer recycled products using less water than traditional methods and minimizing our carbon footprint. And due to its weave, high absorbency and quick dry time, you can clean with fewer harsh chemicals and wash it less often, reducing yours. \n\nImpact your home, not the environment. Discover the Geometry Tea Towel.\n',
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:38.310Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
